<template>
  <ui-modal
    :show="showHistory"
    type="tag"
    title="竞猜记录"
    @close="showHistory = false"
  >
    <div class="history-box">
      <ui-frame-bg class="quizList-box" colorType="blue-light">
        <ul class="quizList">
          <li
            v-for="(type, key) in quizType"
            :key="key"
            :class="{ active: subType === type.id }"
            @click="switchType(type.id)"
          >
            <ui-frame-bg class="bg-active" colorType="yellow"></ui-frame-bg>
            <div class="label-box">
              <span class="label-shadow">{{ type.name }}</span>
              <span class="label-text">{{ type.name }}</span>
            </div>
          </li>
        </ul>
      </ui-frame-bg>

      <div class="switch-source">
        <ui-frame-bg class="switch-btn" colorType="blue" hook @click.native="showSelect = !showSelect">
          <div class="label-box">
            <span class="label-shadow">{{ subNavObj?.name }}</span>
            <span class="label-text">{{ subNavObj?.name }}</span>
          </div>
          <i :class="{ active: showSelect }"></i>
        </ui-frame-bg>
        <SelectList
          class="switch-list-box"
          v-show="showSelect"
          :list="navList"
          defaultID=""
          @handleSwitch="switchNav"
          :showSelect="showSelect"
          :displaySelect=displaySelect
          hook="px"
        ></SelectList>
      </div>

      <div class="inner">
        <div class="history">
          <ul class="history-list" v-if="quizList_ && quizList_.length != 0">
            <li v-for="(history, key) in quizList_" :key="key">
              <div class="header">
                <div class="title">
                  <div class="label-box">
                    <span class="label-shadow">{{ history.title }}</span>
                    <span class="label-text">{{ history.title }}</span>
                  </div>
                </div>
                <div class="date">
                  <div class="label-box">
                    <span class="label-shadow">{{ formatDay(history.scheduleCode) }}</span>
                    <span class="label-text">{{ formatDay(history.scheduleCode) }}</span>
                  </div>
                </div>
                 <!-- <div class="date">{{ history }}</div> -->
              </div>
              <div class="des">
                <div class="quiz">
                  预测：<span>{{ history.quizAnswer }}</span>
                </div>
                <div
                  class="answer"
                  :class="{ normal: $lg(history, 'matchCode', 0) == 0 }"
                >
                  <div class="label">竞猜结果：</div>
                  <div
                    v-if="$lg(history, 'realAnswer', []).length != 0"
                    class="list"
                  >
                    <span
                      v-for="(item, i) in $lg(history, 'realAnswer')"
                      :key="i"
                      >{{ item.answer }}</span
                    >
                  </div>
                  <span v-else>-</span>
                </div>
                <div v-if="$lg(history, 'matchCode', 0) != 0" class="match">
                  局数：
                  <span>第{{ matchZh[Number(history.matchCode)] }}局</span>
                </div>
                <div class="odds">
                  赔率：<span>{{ history.lossRate }}</span>
                </div>
                <div class="betting">
                  投注：<span>{{ history.goldNum }}</span>
                </div>
                <div class="amount-get">
                  猜中可得：
                  <span>{{
                    Math.round(history.goldNum * history.lossRate)
                  }}</span>
                </div>
              </div>
              <div class="status" :class="[`status-${history.status}`]"></div>
            </li>
          </ul>
          <Interdict v-else class="data-none" tip="暂无竞猜记录" hook="px" />
        </div>
      </div>
    </div>
    <Prompt ref="prompt" hook="px"></Prompt>
  </ui-modal>
</template>

<script>
import { mapState } from "vuex";
import * as api from "@/service/index";
import Prompt from "@/components/prompt";
import UiModal from "@/components/ui-modal.vue";
import UiFrameBg from "@/components/ui-frame-bg.vue";
import SelectList from "@/components/select";
import Interdict from "@/components/interdict";

export default {
  components: {
    Prompt,
    UiModal,
    UiFrameBg,
    SelectList,
    Interdict,
  },
  data() {
    return {
      showHistory: false,
      navList: [
        { id: "", name: "全部记录" },
        { id: 0, name: "待开奖" },
        { id: 1, name: "中奖" },
        { id: 2, name: "未中奖" },
      ],
      subNav: "",
      subNavObj: {},
      subType: 1,
      quizType: [
        { id: 1, name: "赛程竞猜" },
        { id: 2, name: "实时竞猜" },
        { id: 3, name: "排名PK" },
        { id: 4, name: "淘汰PK" },
      ],
      quizList: [],
      dateZh: ["日", "一", "二", "三", "四", "五", "六"],
      matchZh: ["", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
      subSeasonID: '',
      showSelect: false,
    };
  },
  computed: {
    ...mapState(["scale", "token", "schedule", "seasonInfo"]),
    quizList_: function () {

      // status  中奖的状态  0:待开奖  1:中奖  2:未中奖
      // type    竞猜的类型  1:赛程竞猜  2:实时竞猜  3:排名PK  4:淘汰PK
      //  当前选择中奖类型 this.subNav
      // 当前选择的竞猜类型 this.subType
      // if (this.subNav !== "") {
      //   return this.quizList.filter(
      //     (item) => item.status === this.subNav && item.type === this.subType 
          
      //   );
      // } else {
      //   console.log('this.subType')
      //   return this.quizList.filter((item) => item.type === this.subType);
      // }
      if (this.subNav !== "") {
        return this.quizList.filter((item) => {
          if (this.subNav === 1) {
            // 当 type 为 1 并且 subNav 为 1 时，返回 status 为 1 或 3 的项目
            return (item.status === 1 || item.status === 3) && item.type === this.subType;
          }  else {
            return item.status === this.subNav && item.type === this.subType;
          }
        })
    } else {
      return this.quizList.filter((item) => item.type === this.subType);
    }
  }
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if(newVal && newVal.id) {
          this.subSeasonID = newVal.id;
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.subNavObj = this.navList[0];
  },
  methods: {
    hideModal() {
      this.showHistory = false;
    },
    async getHistory() {
      this.showHistory = true;

      if(!this.token) return;
      let data = {
        token: this.token,
        seasonId: this.subSeasonID
      };
      let response = await api.reqQuizList(data);
      if (response.status == 200) {
        this.quizList = response.data;
      } else {
        this.$refs.prompt.setMsg(response.data);
      }
    },
    switchNav(navID) {
      this.subNav = navID;
      this.subNavObj = this.navList.find(item => item.id === navID);
    },
    switchType(typeID) {
      this.subType = typeID;
    },
    formatDay(scheduleCode) {
      if (this.schedule && this.schedule.length != 0) {
        const schedule = this.schedule.find(
          (item) => item.scheduleCode == scheduleCode
        );
        let startAt = new Date(schedule.startAt);
        let month = startAt.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        let day = startAt.getDate();
        day = day < 10 ? "0" + day : day;

        return `${month}月${day}日 周${this.dateZh[startAt.getDay()]} ${
          schedule.name
        }`;
      } else {
        return "";
      }
    },
    displaySelect() {
      this.showSelect = false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/quiz/history";
</style>